import React, { Fragment, useMemo, useState, useEffect } from "react";
import { Spinner, Button, Card, Row, Col, Modal, Form } from "react-bootstrap";
import { useCookies } from "react-cookie";
import {
  getUserGroups,
  createUserGroup,
  getCourses,
  getUsers,
} from "ServerAPI/serverAPI";
import TanstackTable from "components/elements/advance-table/TanstackTable";
import CommonHeader from "layouts/dashboard/CommonHeader";
import userGroupIcon from "../../assets/images/Users.svg";
import actionIcon from "../../assets/images/course/action-icon.svg";
import Select from "react-select";
import Multiselect from "multiselect-react-dropdown";
import SearchIcon from "@mui/icons-material/Search";
import { TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";


import _, { stubTrue } from "lodash";
import RefreshButton from "components/elements/refresh-button/RefreshButton";
import CommonDialog from "components/Dialog/CommonDialog";
import UpdateUserGroup from "./UpdateUserGroup";
import { useToast } from "context/toast-context/ToastProvider";


const UserGroups = () => {
  const navigate = useNavigate();
  const [cookies] = useCookies();
  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState([]);
  // const [loading, setLoading] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const [formData, setFormData] = useState({
    groupName: "",
    startDate: "",
    endDate: "",
  });
  const [selectedCourses, setSelectedCourses] = useState([]);
  const [courseList, setCourseList] = useState([]);
  const [programCoordinators, setProgramCoordinators] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const { showToast } = useToast();

  const formatDisplayDate = (dateString) => {
    if (!dateString) return "N/A";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-IN', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    } catch (error) {
      return dateString;
    }
  };

  const fetchUserGroups = async () => {
    try {
      const email = cookies.email;
      const organizationId = cookies.organizationId;
      const userId = cookies.userId;
      setLoadingTable(true);
      const response = await getUserGroups(email, organizationId, userId);
      const formattedData = response.data.map((group, index) => ({
        id: index + 1,
        name: group.userGroupName,
        deptName: group.department,
        startDate: formatDisplayDate(group?.startDate?.$date),
        endDate: formatDisplayDate(group?.endDate?.$date),
        userGroupId: group.userGroupId,
        courseIds: group?.courseIds,
        userIds: group?.userIds,
      }));
      setData(formattedData);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
    setLoadingTable(false);
  };

  useEffect(() => {
    fetchUserGroups();
  }, []);

  const fetchModalData = async () => {
    try {
      const email = cookies.email;
      const roleId = cookies.roleId;
      const organizationId = cookies.organizationId;
      setLoadingModal(true);
      const res = await getCourses(
        email,
        roleId,
        cookies.organizationId,
        cookies.department,
        cookies.userId
      );
      const users = await getUsers(email, roleId, organizationId);
      if (roleId !== "programCoordinator") {
        const pcData = users?.data?.users?.filter(
          (user) =>
            user?.role?.roleId === "programCoordinator" &&
            user?.organizationId === cookies?.organizationId
        );

        setProgramCoordinators(pcData);
      } else {
        setProgramCoordinators([]);
      }
      const participants = users?.data?.users?.filter(
        (user) =>
          user?.role?.roleId === "courseParticipant" &&
          user?.organizationId === cookies?.organizationId
      );
      setUsersList(participants);
      setCourseList(res.data);
    } catch (error) {
      console.error("Error fetching modal data:", error);
    }
    setLoadingModal(false);
  };

  useEffect(() => {
    if (showModal) {
      fetchModalData();
    }
  }, [showModal]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: () => (
          <span style={{ fontWeight: "bold", color: "#224D99" }}>SN</span>
        ),
      },
      {
        accessorKey: "name",
        header: () => (
          <span style={{ fontWeight: "bold", color: "#224D99" }}>Name</span>
        ),
      },
      {
        accessorKey: "deptName",
        header: () => (
          <span style={{ fontWeight: "bold", color: "#224D99" }}>
            Department
          </span>
        ),
      },
      {
        accessorKey: "startDate",
        header: () => (
          <span style={{ fontWeight: "bold", color: "#224D99" }}>Start</span>
        ),
        cell: ({ row }) => (
          <>
            <span>{(row.original.startDate)}</span>
          </>
        ),
      },
      {
        accessorKey: "endDate",
        header: () => (
          <span style={{ fontWeight: "bold", color: "#224D99" }}>End</span>
        ),
        cell: ({ row }) => (
          <>
            <span>{(row.original.endDate)}</span>
          </>
        ),
      },
      {
        accessorKey: "vieww",
        header: () => (
          <span style={{ fontWeight: "bold", color: "#224D99" }}>View</span>
        )
        ,
        cell: ({ row }) => (
          <img
            src={actionIcon}
            alt="action icon"
            style={{ cursor: "pointer" }}
            onClick={() => {
              navigate(`/user-groups/${row.original.userGroupId}`);
            }}
          />

        ),
      },
    ],
    [navigate]
  );

  const handleModalClose = () => setShowModal(false);
  const handleModalShow = () => setShowModal(true);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    let userId = cookies.userId;

    if (cookies.roleId === "organizationCoordinator") {
      console.log(formData);
      userId = formData.programCoordinator;
    }

    try {
      const body = {
        userGroupName: formData.groupName,
        courseIds: selectedCourses,
        courseTitles: courseList
          .filter((course) => selectedCourses.includes(course.courseId))
          .map((course) => course.courseTitle),
        userIds: selectedUsers,
        organizationId: cookies.organizationId,
        authorUserId: userId,
        startDate: new Date(formData.startDate).toISOString(),
        endDate: new Date(formData.endDate).toISOString(),
      };

      const response = await createUserGroup(body);

      if (response.status === 200) {
        showToast("User group created successfully!", "success");
        handleModalClose();
        // Reset form fields after successful submit
        setFormData({
          groupName: "",
          startDate: "",
          endDate: "",
          programCoordinator: "",
        });
        setSelectedCourses([]);
        setSelectedUsers([]);
        fetchUserGroups();
      } else {
        const errorMsg = response?.data?.message || "Failed to create user group.";
        console.log("Error creating user group message:", errorMsg);
        showToast(errorMsg, "error");
      }
    } catch (error) {
      console.error("Error creating user group:", error);
      const errMsg =
        error?.response?.data?.message || "An error occurred while creating the user group.";
      showToast(errMsg, "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleRefresh = async () => {
    setIsRefreshing(true);
    await fetchUserGroups();
    setIsRefreshing(false);
  };

  
  return (
    <Fragment>
      <Row>
        <Col>
          <CommonHeader
            text="Training Program"
            subText="View & Manage your training programs here"
            icon={userGroupIcon}
          />
        </Col>
      </Row>
      <Row className="mx-auto">
        <Col sm={10} className="mx-auto pt-5 px-0">
          <Card>
            <Card.Body className="p-3">
              <div className="d-flex justify-content-between align-items-center mt-2 mb-3">
                <div className="fw-bold text-dark fs-3">
                  Training Program Data
                </div>

                <div className="d-flex align-items-center gap-4">
                  <RefreshButton
                    handleRefresh={handleRefresh}
                    title="Refresh Domain"
                    isRefreshing={isRefreshing}
                  />
                  <Button
                    onClick={handleModalShow}
                    style={{ background: "#224D99" }}
                  >
                    + Add
                  </Button>
                </div>
              </div>
              <hr />
              {loadingTable ? (
                <div className="text-center p-4">
                  <Spinner animation="border" />
                </div>
              ) : (
                <TanstackTable
                  data={data}
                  columns={columns}
                  pagination={true}
                />
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Modal show={showModal} onHide={handleModalClose} centered>
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "rgba(34, 75, 153, 1)" }}>
            Add Training Program Details
          </Modal.Title>
        </Modal.Header>
        {loadingModal ? (
          <div className="text-center p-4">
            <Spinner animation="border" />
          </div>
        ) : (
          <Modal.Body>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Program Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Program Name"
                      name="groupName"
                      value={formData.groupName}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                {cookies.roleId === "organizationCoordinator" && (
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>Program Coordinator</Form.Label>
                      <Form.Select
                        name="programCoordinator"
                        value={formData.programCoordinator}
                        onChange={handleChange}
                        required
                      >
                        <option value="" disabled selected>
                          Select a Coordinator
                        </option>
                        {programCoordinators.map((coordinator, index) => (
                          <option key={index} value={coordinator.userId}>
                            {coordinator.name}
                          </option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                  </Col>
                )}
              </Row>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Start Date</Form.Label>
                    <Form.Control
                      type="date"
                      name="startDate"
                      value={formData.startDate}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>End Date</Form.Label>
                    <Form.Control
                      type="date"
                      name="endDate"
                      value={formData.endDate}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
  
                  <Form.Group className="mb-3">
                    <Form.Label>Courses</Form.Label>
<Multiselect
  options={courseList}  
  displayValue="courseTitle" 
  selectedValues={courseList.filter(course =>
    selectedCourses.includes(course.courseId)
  )}
  onSelect={selectedList =>
    setSelectedCourses(selectedList.map(course => course.courseId))
  }
  onRemove={selectedList =>
    setSelectedCourses(selectedList.map(course => course.courseId))
  }
  placeholder="Search Courses"
  showCheckbox={true}
  closeOnSelect={false} // keeps dropdown open after each selection

     
    // Custom inline style override to handle background colors
      style={{
          option: {
            backgroundColor: '#f5f7fa', // very light gray blue
            color: '#2c3e50',           // dark slate blue
          },
          selectedOption: {
            backgroundColor: '#7fb3d5', // soft blue
            color: 'white',
          },
          chips: {
            backgroundColor: '#85cbfdff', // light blue-gray
            color: 'black',           // medium blue text
            fontWeight: '500'
          },
          searchBox: {
            border: '1px solid #ccd6e0',
            borderRadius: '6px',
            padding: '8px',
          },
          optionContainer: {
            maxHeight: '180px',
            overflowY: 'auto',
          },
        }}
      
/>
                  </Form.Group>
       </Row>
       <Row>
             
                  <Form.Label>Add User</Form.Label>
<Multiselect
  options={usersList}
  displayValue="name"
  selectedValues={usersList.filter(user => selectedUsers.includes(user.userId))}
  onSelect={selectedList => setSelectedUsers(selectedList.map(user => user.userId))}
  onRemove={selectedList => setSelectedUsers(selectedList.map(user => user.userId))}
  placeholder="Search a User"
  showCheckbox={true}
  closeOnSelect={false}
  
    // Custom inline style override to handle background colors
      style={{
          option: {
            backgroundColor: '#f5f7fa', // very light gray blue
            color: '#2c3e50',           // dark slate blue
          },
          selectedOption: {
            backgroundColor: '#7fb3d5', // soft blue
            color: 'white',
          },
          chips: {
            backgroundColor: '#85cbfdff', // light blue-gray
            color: 'black',           // medium blue text
            fontWeight: '500'
          },
        }}

/>

              </Row>

<div
  className="d-flex justify-content-end"
  style={{ marginTop: "20px" }}  // Adjust the value as needed
>
  <Button
    variant="secondary"
    onClick={handleModalClose}
    className="me-2"
    style={{
      backgroundColor: "transparent",
      color: "rgba(34, 75, 153, 1)",
    }}
  >
    Cancel
  </Button>
  <Button
    variant="primary"
    type="submit"
    disabled={isSubmitting}
  >
    {isSubmitting ? (
      <Spinner animation="border" size="sm" />
    ) : (
      "Create"
    )}
  </Button>
</div>

            </Form>
          </Modal.Body>
        )}
      </Modal>


    </Fragment>
  );
};

export default UserGroups;
